import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import CommunityListing from 'views/admin/community/CommunityListing'
import PostFullView from 'views/admin/community/PostFullView'

const CommunityRoutes = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <CommunityListing />
      </Route>
      <Route path={`${path}/:postId`}>
        <PostFullView displayContext="page" />
      </Route>
    </Switch>
  )
}

export default CommunityRoutes
